import ReactDom from 'react-dom/client'
import {RecoilRoot, RecoilEnv} from 'recoil'
import {CookiesProvider} from 'react-cookie'
import {BrowserRouter} from 'react-router-dom'
import './global.css'

import App from './app'

// Dev 모드의 Recoil Caution 숨김용 ( 삭제해도 무방 )
RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = false

ReactDom.createRoot(document.getElementById('root')).render(
	<CookiesProvider>
		<RecoilRoot>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</RecoilRoot>
	</CookiesProvider>
)
